module.exports = __webpack_public_path__ + "img/project7_1.png.ffbb2c0c.webp";